import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ImagePlus, Sparkles, Trash2, ImageIcon } from "lucide-react";
import { AiImageDialog } from "./AiImageDialog";

// Wiederverwendbares Feld für das Hero-Bild (unter dem Header der E-Mail).
// value/onChange arbeiten mit einem Pfad/URL (z. B. /api/mailing/assets/... oder https://...).
export function HeroImageField({ value, onChange }) {
  const [aiOpen, setAiOpen] = useState(false);
  const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const previewSrc = value
    ? value.startsWith("http")
      ? value
      : `${backendUrl}${value}`
    : null;

  return (
    <div className="space-y-2">
      <Label className="flex items-center gap-1.5">
        <ImageIcon className="w-3.5 h-3.5" /> Hero-Bild (unter dem Header)
      </Label>
      {previewSrc ? (
        <div className="relative rounded-lg border overflow-hidden bg-muted/30" data-testid="hero-image-preview-wrap">
          <img src={previewSrc} alt="Hero-Vorschau" className="w-full h-auto block max-h-48 object-cover" data-testid="hero-image-preview" />
          <Button
            type="button"
            size="icon"
            variant="destructive"
            className="absolute top-2 right-2 h-7 w-7"
            onClick={() => onChange("")}
            data-testid="hero-image-remove"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </Button>
        </div>
      ) : (
        <div className="rounded-lg border border-dashed p-4 text-center text-sm text-muted-foreground" data-testid="hero-image-empty">
          Kein Hero-Bild gewählt. Erzeuge eines mit KI oder gib eine Bild-URL ein.
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2">
        <Button type="button" variant="outline" size="sm" onClick={() => setAiOpen(true)} data-testid="hero-image-ai-btn">
          <Sparkles className="w-4 h-4 mr-2" /> KI-Bild erzeugen
        </Button>
        <div className="flex-1 min-w-[180px]">
          <Input
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="oder Bild-URL einfügen (https://…)"
            data-testid="hero-image-url-input"
          />
        </div>
      </div>
      <AiImageDialog open={aiOpen} onOpenChange={setAiOpen} onGenerated={(path) => onChange(path)} />
    </div>
  );
}
